module.exports = __webpack_public_path__ + "static/media/ig.763b4ef3.svg";